<template>
  <div class="login">
    <b-container class="p-0 pm-2">
      <b-card class="card-login pb-4">
        <img v-if="logoSrc" :src="getImgUrl(logoSrc)" class="d-block mx-auto" />
        <img v-if="logoURL" :src="logoURL" class="d-block mx-auto" />

        <h2 v-if="titleH2" class="mt-3 mb-4" v-html="titleH2"></h2>
        <b-row>
          <b-col>
            <h6 v-if="welcomeHeader" class="welecomeH6 mt-3" v-bind:class="[{
              welecomeMIDH6: guard == 'MID',
              welecomeDYH6: guard == 'DY',
              welecomeDoorderH6: guard == 'DOORDER',
              welecomeAVH6: guard == 'AV',
              welcomeGHH6: guard == 'GARDENHELP',
              welcomeCRiskH6: guard == 'CRISK',

            }, welcome_header_class]">
              {{ welcomeHeader }}
            </h6>
            <p v-if="welcomeSubheader" class="welcomeP" v-bind:class="[{
              welecomeMIDP: guard == 'MID',
              welecomeDYP: guard == 'DY',
              welecomeDoorderP: guard == 'DOORDER',
              welecomeAVP: guard == 'AV',
              welcomeGHP: guard == 'GARDENHELP',
              welcomeCRiskP: guard == 'CRISK',
            }, welcome_subheader_class]">
              {{ welcomeSubheader }}
            </p>
          </b-col>
        </b-row>
        <b-row><b-col>
            <!-- -->
            <b-alert v-model="showLoginErrorMessage" variant="danger" :class="[{
              'alert-danger-dy': guard == 'DY',
              'alert-danger-doorder': guard == 'DOORDER',
              'alert-danger-av': guard == 'AV',
              'alert-danger-garden-help': guard == 'GARDENHELP',
            }, alert_danger_class]">{{ loginErrorMessage }}
            </b-alert>
          </b-col></b-row>
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group id="email-input-group" :label="guard == 'CRISK' || guard == 'PROTOSTARS' ? $t('email') : ''"
                label-for="email" :label-class="[{
                }, form_label_auth_class]">
                <b-form-input class="form-control-auth" v-bind:class="[{
                  'form-control-auth-mid': guard == 'MID',
                  'form-control-auth-doom-yoga': guard == 'DY',
                  'form-control-auth-doorder': guard == 'DOORDER',
                  'form-control-auth-astrology': guard == 'AV',
                  'form-control-auth-garden-help': guard == 'GARDENHELP',
                  'form-control-auth': guard == 'bumblebee'
                }, form_control_auth_class]" id="email" v-model="form.email" type="email" :placeholder="$t('email')"
                  autofocus @keydown.space.prevent required></b-form-input>
              </b-form-group></b-col></b-row>
          <b-row>
            <b-col>
              <b-form-group id="password-input-group"
                :label="guard == 'CRISK' || guard == 'PROTOSTARS' ? $t('password') : ''" label-for="password"
                :label-class="[form_label_auth_class]">
                <b-input-group class="input-group-password">

                  <b-form-input class="form-control-auth" v-bind:class="[{
                    'form-control-auth-mid': guard == 'MID',
                    'form-control-auth-doom-yoga': guard == 'DY',
                    'form-control-auth-doorder': guard == 'DOORDER',
                    'form-control-auth-astrology': guard == 'AV',
                    'form-control-auth-garden-help': guard == 'GARDENHELP',
                    'form-control-auth': guard == 'bumblebee'
                  }, form_control_auth_class]" id="password" v-model="form.password"
                    :type="show_password ? 'text' : 'password'" :placeholder="$t('password')" required></b-form-input>
                  <b-input-group-append>
                    <b-button @click="show_password = !show_password"><font-awesome-icon icon="fa-solid fa-eye"
                        v-if="!show_password" />
                      <font-awesome-icon icon="fa-solid fa-eye-slash" v-else /></b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group></b-col></b-row>
          <div class="row" v-bind:class="[{
            forgetPasswordRowMidDiv: guard == 'MID',
            forgetPasswordRowDYDiv: guard == 'DY',
            forgetPasswordRowDoorderDiv: guard == 'DOORDER',
            forgetPasswordRowAVDiv: guard == 'AV',
            forgetPasswordRowGHDiv: guard == 'GARDENHELP',
          }, forget_password_row_class]">
            <div class="col-md-6 mt-1 mb-md-4 mb-0 pl-0">
              <div class="form-check" v-bind:class="[{
                'form-check-mid': guard == 'MID',
                'form-check-dy': guard == 'DY',
                'form-check-doorder': guard == 'DOORDER',
                'form-check-av': guard == 'AV',
                'form-check-garden-help': guard == 'GARDENHELP',
              }, form_check_class]">
                <label class="form-check-label" for="remember-me">
                  <input type="checkbox" class="form-check-input" id="remember-me" name="remember" />
                  {{ $t("remember_me") }}
                  <span class="form-check-sign">
                    <span class="check"></span>
                  </span>
                </label>
              </div>
            </div>
            <div class="col-md-6 mt-2 mb-md-4 mb-2 pr-0">
              <router-link class="float-end" v-bind:class="[{
                forgetPasswordMidA: guard == 'MID',
                forgetPasswordDYA: guard == 'DY',
                forgetPasswordDoorderA: guard == 'DOORDER',
                forgetPasswordAVA: guard == 'AV',
                forgetPasswordGHA: guard == 'GARDENHELP',
              }, forget_password_link_class]"
                :to="'/' + clientLink + '/forget_password' + (user_type ? '/' + user_type : '')">{{
                  $t('forget_password_title') }}?
              </router-link>
            </div>
          </div>
          <input type="hidden" name="guard" v-model="guard" />
          <div class="d-flex justify-content-center align-content-center" :class="[{
            submitButtonContainerGH: guard === 'GARDENHELP',
          }, submit_button_container_class]">
            <button v-if="!is_loading" class="btn" v-bind:class="[{
              'btn-login-mid': guard === 'MID',
              'btn-login-dy': guard === 'DY',
              'btn-login-doorder': guard === 'DOORDER',
              'btn-login-av': guard === 'AV',
              'btn-login-garden-help': guard === 'GARDENHELP',
              'btn-login': project === 'bumblebee'
            }, btn_login_class]" type="submit">
              {{ $t('login_btn') }}
            </button>
            <button v-else class="btn" disabled v-bind:class="[{
              'btn-login-mid': guard === 'MID',
              'btn-login-dy': guard === 'DY',
              'btn-login-doorder': guard === 'DOORDER',
              'btn-login-av': guard === 'AV',
              'btn-login-garden-help': guard === 'GARDENHELP',
              'btn-login': project === 'bumblebee'
            }, btn_login_class]" type="button">
              <b-spinner small label="Small Spinner" variant="light"></b-spinner>
              {{ $t('loading') }}
            </button>
          </div>
          <div class="d-flex justify-content-center align-content-center mt-4"
            v-if="guard == 'DY' && user_type == null">
            <p v-bind:class="{
              rememberPasswordMIDP: guard == 'MID',
              rememberPasswordDYP: guard == 'DY',
              rememberPasswordDoorderP: guard == 'DOORDER',
              rememberPasswordAVP: guard == 'AV',
              rememberPasswordGHP: guard == 'GARDENHELP',
            }">
              Don’t have an account?
              <router-link :to="'/' + clientLink + '/sign_up'">Sign up
              </router-link>
            </p>
          </div>
          <div class="d-flex justify-content-center align-content-center mt-4"
            v-if="(guard == 'PROTOSTARS') && user_type == null">
            <p v-bind:class="[ remember_password_p]">
              {{ $t('new_on_platform') }}
              <router-link :to="'/' + clientLink + '/customer/register'" :class="[forget_password_link_class]">{{
                $t('create_accoutn') }}
              </router-link>
            </p>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  name: "Login",
  props: [
    "titleH2",
    "logoSrc",
    "logoURL",
    "guard",
    "welcomeHeader", "welcome_header_class",
    "welcomeSubheader", "welcome_subheader_class",
    "alert_danger_class", "form_label_auth_class", "form_control_auth_class",
    "forget_password_row_class", "form_check_class", "forget_password_link_class",
    "submit_button_container_class", "btn_login_class",
    "remember_password_p",

    "clientLink",
    "project"
  ],
  data() {
    return {
      form: {
        email: "",
        password: "",
        guard: this.guard,
      },
      showLoginErrorMessage: false,
      loginErrorMessage: "",
      user_type: "",
      swal_confirm_button_class: "",
      swal_container_class: "",
      show_password: false,
      is_loading: false

    };
  },
  mounted() {
    // console.log(window.localStorage.getItem("user"));
    this.user_type = this.$route.params.type;
    console.log(this.user_type == null, this.guard);

    if (this.guard == "GARDENHELP") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-gardenhelp  btn-gardenhelp-primary";
      this.swal_container_class = "swal-container-garden-help";
    } 
  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      // console.log(window.localStorage);
      console.log("login submit", this.user_type);
      // console.log(this.$parent.$parent.isLogin);

     
        if (
          (this.user_type != null && this.guard == "DY") ||
          (this.user_type != null && this.guard == "AV") ||
          this.guard == "MID" ||
          (this.user_type != null && this.guard == "DOORDER") ||
          (this.user_type == 'admin' && this.guard == "GARDENHELP")
        ) {
          console.log("else user type (admin) ", this.guard, this.form.guard);

          axios
            .post("admin/login", {
              email: this.form.email,
              password: this.form.password,
              client: this.form.guard,
            })
            .then((response) => {
              console.log(response);
              console.log(response.data);
              this.loginErrorMessage = "";
              this.showLoginErrorMessage = false;
              window.localStorage.setItem("user", JSON.stringify(response.data));
              window.localStorage.setItem("user_type", "admin");
              // // this.$parent.$parent.isLogin = true;
              console.log(this.form.guard);
              if (this.form.guard === "MID") {
                this.$router.go({ name: "MIDDashboard" });
              } else if (this.form.guard === "DY") {
                this.$router.go({ name: "DoOmYogaDashboard" });
              } else if (this.form.guard === "AV") {
                this.$router.go({ name: "AstrologyDashboard" });
              } else if (this.form.guard === "DOORDER") {
                this.$router.go({ name: "DoorderDashboard" });
              } else if (this.form.guard === "GARDENHELP") {
                console.log("success login gh");
                this.$router.go({ name: "GardenHelpAdminHome" });
                // this.$router.go({ name: "DoorderDashboard" });
                // localStorage.removeItem("user");

                // this.$fire({
                //   // title: "Title",
                //   text: "You have logged in successfully",
                //   type: "success",
                //   // timer: 3000,
                //   customClass: {
                //     container: this.swal_container_class,
                //     confirmButton: this.swal_confirm_button_class,
                //   },
                // }).then((r) => {
                //   // console.log(r.value);
                // });
                // document.body.classList.remove("swal2-height-auto");
              } 
              else if (this.form.guard === "PROTOSTARS") {
                console.log("success login protostars");
                this.$router.go({ name: "ProtostarsAdminHome" });
              }
            })
            .catch((error) => {
              console.log(error);
              console.log(error.response.data.error);
              console.log(error.request);
              console.log(error.message);
              this.loginErrorMessage = error.response.data.error;
              this.showLoginErrorMessage = true;
            });
        }
        else if (
          (this.user_type == 'contractor' && this.guard == "GARDENHELP")
        ) {
          console.log("else user type (contractor) ", this.guard, this.form.guard);

          axios
            .post("operator/login", {
              email: this.form.email,
              password: this.form.password,
              client: this.form.guard,
            }, {
              headers: {
                client: this.form.guard,
              },
            })
            .then((response) => {
              console.log(response);
              console.log(response.data);
              this.loginErrorMessage = "";
              this.showLoginErrorMessage = false;
              window.localStorage.setItem("user", JSON.stringify(response.data));
              window.localStorage.setItem("user_type", "operator");
              // // this.$parent.$parent.isLogin = true;
              console.log(this.form.guard);
              if (this.form.guard === "GARDENHELP") {
                console.log("success login gh");
                this.$router.go({ name: "GardenHelpContractorHome" });
              }

            })
            .catch((error) => {
              console.log(error);
              console.log(error.response.data.error);
              console.log(error.request);
              console.log(error.message);
              this.loginErrorMessage = error.response.data.error;
              this.showLoginErrorMessage = true;
            });
        } else {
          console.log("before go customer home");
          axios
            .post("user/login", {
              email: this.form.email,
              password: this.form.password,
              client: this.form.guard,
            })
            .then((response) => {
              console.log(response);
              console.log(response.data);

            
                window.localStorage.setItem("user", JSON.stringify(response.data));
                window.localStorage.setItem("user_type", "user");
                window.localStorage.setItem("customer", true);
                // // this.$parent.$parent.isLogin = true;
                if (this.form.guard === "DY") {
                  this.$router.go({ name: "DoOmYogaCustomerHome" });
                } else if (this.form.guard === "DOORDER") {
                  this.$router.go({ name: "DoOrderOrdersList" });
                } else if (this.form.guard === "GARDENHELP") {
                  console.log("success login gh");
                  this.$router.go({ name: "GardenHelpCustomerHome" });
                }
                // else if (this.form.guard === "CRISK") {
                //   // this.$router.go({ name: "GardenHelpAdminHome" });
                //   this.$router.go({ name: "CRiskGlossaryList" });
                //   // localStorage.removeItem("user");

                //   // this.$fire({
                //   //   // title: "Title",
                //   //   text: "You have logged in successfully",
                //   //   type: "success",
                //   //   // timer: 3000,
                //   //   customClass: {
                //   //     container: this.swal_container_class,
                //   //     confirmButton: this.swal_confirm_button_class,
                //   //   },
                //   // }).then((r) => {
                //   //   // console.log(r.value);
                //   // });
                //   // document.body.classList.remove("swal2-height-auto");
                // }

              


            })
            .catch((error) => {
              console.log(error.response.data.error);
              console.log(error.request);
              console.log(error.message);
              this.loginErrorMessage = error.response.data.error;
              this.showLoginErrorMessage = true;
            });
        }
      


    },

    
  },
};
</script>


// WEBPACK FOOTER //
// src/components/auth/Login.vue